export const COLLECTION = {
  USERS: 'users',
  NOTIFICATIONS: 'notifications',
  SETTINGS: 'settings',
  BUSINESS_EVENTS: 'business-events',
  REPORTS: 'reports',
  USER_SUBSCRIPTIONS: 'subscriptions',
  API_TOKENS: 'api-tokens',
  STATS_PER_MONTH: 'stats-per-month',
  CLIENTS: 'clients',
  INVITATIONS: 'invitations',
  TEAM_MEMBERS: 'team-members',
  NOTES: 'notes',
  COSTS: 'costs',
  BANK_OFFERS: 'bank-offers',
  APPLICATIONS: 'applications',
  CLIENT_STATUSES: 'client-statuses',
  CLIENT_SOURCES: 'client-sources',
  SUPPORT_THREADS: 'support-threads',
  CALL_REMINDERS: 'call-reminders',
  CLIENT_OFFERS: 'client-offers',
  FILE_ENTRIES: 'file-entries',
  LAUNCHES: 'launches',
  CALENDAR_EVENTS: 'calendar-events',
  UPLOAD_TOKENS: 'upload-tokens',
} as const;
